import { render, staticRenderFns } from "./UpcomingWorkingShiftView.vue?vue&type=template&id=1f566f6e&scoped=true"
import script from "./UpcomingWorkingShiftView.vue?vue&type=script&lang=js"
export * from "./UpcomingWorkingShiftView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f566f6e",
  null
  
)

export default component.exports